import React from 'react';
import PropTypes from 'prop-types';

import Link from 'components/link';
import OrderListItem from './order-list-item';
import Text from 'components/text';

const OrderList = ({ columnLabels, orderAgain, rows }) => (
  <div className="order-list">
    <table>
      <thead>
        <tr>
          {columnLabels.map(label => (
            <Text element="th" key={label} theme={Text.themes.small}>
              {label}
            </Text>
          ))}
        </tr>
      </thead>

      <tbody>
        {rows.map((row, i) => (
          <OrderListItem key={i} {...row} />
        ))}
      </tbody>
    </table>

    <div className="order-list-button-container">
      {orderAgain && (
        <Link
          iconAfter="basket"
          themes={[Link.themes.buttonGray]}
          {...orderAgain}
        />
      )}
    </div>
  </div>
);

OrderList.defaultProps = {
  columnLabels: [],
  rows: []
};

OrderList.propTypes = {
  columnLabels: PropTypes.arrayOf(PropTypes.string),
  orderAgain: PropTypes.exact(Link.propTypes),
  rows: PropTypes.arrayOf(PropTypes.exact(OrderListItem.propTypes))
};

export default OrderList;
